
import React from "react";
import { Button } from "@/components/ui/button";
import { LoadingButton } from "@/components/ui/loading-button";
import { FormInput } from "@/components/ui/form-input";

type Props = {
  areaCode: string;
  setAreaCode: (v: string) => void;
  error: string | null;
  onPrev: () => void;
  onSubmit: (e: React.FormEvent) => void;
  loading: boolean;
  existingNumbersCount: number;
  setShowBuyNew: (v: boolean) => void;
  setError: (e: string | null) => void;
};

const Step2NumberBuyNew: React.FC<Props> = ({
  areaCode,
  setAreaCode,
  error,
  onPrev,
  onSubmit,
  loading,
  existingNumbersCount,
  setShowBuyNew,
  setError,
}) => (
  <form className="space-y-4" onSubmit={onSubmit}>
    <div>
      <h3 className="text-lg font-medium mb-2">Buy a new phone number</h3>
      <p className="text-muted-foreground mb-4">
        Enter an area code to purchase a new phone number in that region.
      </p>
    </div>
    <FormInput
      label="Area Code"
      maxLength={5}
      value={areaCode}
      onChange={(e) => setAreaCode(e.target.value)}
      placeholder="e.g. 416"
    />
    {error && <div className="text-red-500 text-sm">{error}</div>}
    <div className="flex space-x-2">
      <Button
        type="button"
        variant="secondary"
        onClick={() => {
          if (existingNumbersCount > 0) {
            setShowBuyNew(false);
            setError(null);
          } else {
            onPrev();
          }
        }}
      >
        Back
      </Button>
      <LoadingButton type="submit" loading={loading}>
        Buy Number
      </LoadingButton>
    </div>
  </form>
);

export default Step2NumberBuyNew;
